/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by GUillermo Castro Reyes <guillermo.castro@ironbit.com.mx>, September 2022
 */
import { cls } from 'packages/components';
import React, { StatelessComponent } from 'react';
import { Button } from 'src/packages/components/lib/Button';
import Asset from 'src/requests/apa/Asset';



export interface IScheduleGroupItemProps {
    title: string
    schedule: IScheduleItemProps[]
}

export interface IScheduleItemProps {
    onClick: ()=>void,
    onFocus: (id: string)=>void,
    onClickButton: ()=>void,
    scheduleRound: string
    scheduleHour: string,
    scheduleTeam: string,
    scheduleLocalImg: string,
    scheduleVisitorImg: string,
    canWatchNow:boolean,
    isScheduled: boolean,
}

export interface IScheduleLabelProps{
    hour: string,
    team : string,
    button_play : string
} 
export interface IScheduleHeaderProps {
    name: string,
    width: string
}

export interface IScheduleProps {
    children?: React.ReactNode;
    label: IScheduleLabelProps, 
    scheduleHeader: any;
    scheduleData: IScheduleGroupItemProps[];
}
/**
 * A World Cup Matches Ribbon
 **/
export const Schedule: StatelessComponent<IScheduleProps> = ({ label, scheduleHeader, scheduleData, children }) => {
    const { headers = [{ name: '', width: '150px' }, { name: label.hour, width: '180px' }, { name: label.team, width: '229px' }, { name: '', width: '164px' }, { name: '', width: '183px' }] } = scheduleHeader;
    let isFirstButton = true;
    let dataOptions:any = {}
    return (
        <div className='worldcup-schedule'>
            <div className='schedule-children'>{children}</div>
            <div className='schedule-table'>
                {scheduleData.map((groups, groupIndex)=>{
                const {title, schedule} = groups;
                return (
                    <table>
                    <caption className='schedule-title'>{title}</caption>
                    <tr>
                        {headers.map((header: IScheduleHeaderProps) => {
                            return <th style={{
                                width: header.width
                            }}>{header.name}</th>
                        })}
                    </tr>
                    {schedule.map((data, rowIndex)=>{
                            const {onClick, onFocus, onClickButton, scheduleHour, scheduleTeam, scheduleLocalImg, scheduleVisitorImg, canWatchNow, isScheduled} = data;
                            dataOptions = {};
                            dataOptions['data-sn-left'] = '';
                            if (isFirstButton) {
                                isFirstButton = false;
                                dataOptions['data-sn-up'] = 'a.btn-filter.focusable';
                            } else {
                                dataOptions['data-sn-up'] = rowIndex > 0 ? `#group-${groupIndex}-row-${rowIndex-1}` :  `#group-${groupIndex - 1}-row-${scheduleData[groupIndex - 1].schedule.length - 1}`;
                            }
                            dataOptions['data-sn-down'] = rowIndex < schedule.length - 1 ? `#group-${groupIndex}-row-${rowIndex+1}` :  `#group-${groupIndex + 1}-row-0`;
                            
                            const id = `group-${groupIndex}-row-${rowIndex}`;
                            return (
                                <tr>
                                    <td>&nbsp;</td>
                                    <td colSpan={3} className='column-3' >
                                        <Button type='button' onClick={onClick} onFocus={()=> onFocus(id)} dataOptions={dataOptions} variant='default' className='schedule-button focusable' id={id}>
                                            <div style={{
                                                width: headers[1].width
                                            }} className='schedule-column'>{scheduleHour}</div>
                                            <div style={{
                                                width: headers[2].width
                                            }} className={cls('schedule-column', scheduleTeam.length >30 ? 'two-lines' : '')}>{scheduleTeam}</div>
                                            <div style={{
                                                width: headers[3].width
                                            }} className='schedule-column'>
                                                <img src={scheduleLocalImg || Asset.get('flag_team_placeholder_img')} alt='HOME' className={`${isScheduled ? 'flag' : 'no-scheduled'} ${!scheduleLocalImg ? 'placeholder-left' : ''}`} />
                                                <img src={scheduleVisitorImg || Asset.get('flag_team_placeholder_img')} alt='VISIT' className={`${isScheduled ? 'flag' : 'no-scheduled'} ${!scheduleVisitorImg ? 'placeholder-right' : ''}`}/>
                                            </div>
                                        </Button>
                                    </td>
                                    <td>
                                        {canWatchNow &&
                                        <Button type='button' onClick={onClickButton} variant='primary' className='schedule-watch-now focusable'>
                                            {label.button_play}
                                        </Button>
                                        }
                                    </td>
                                </tr>
                            )
                    })}
                </table>
                );
                })}
            </div>
        </div>
    );
}






// WEBPACK FOOTER //
// ./src/mundial/Tabs/Calendar/schedule.tsx